import AlertBox from './AlertBox.vue';

const install = function(Vue) {
  Vue.component('AlertBox', AlertBox);
};

/* istanbul ignore if */
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

export { AlertBox };

export default {
  version: '1.0.0',
  install,
  AlertBox,
  AlertBox: AlertBox
};
// const AlertBox = {
//   install(Vue, options) {
//     Vue.component('alert-box', vueAlertBox);
//   }
// };
// if (typeof window !== 'undefined' && window.Vue) {
//   window.Vue.use(AlertBox);
// }
// // export { AlertBox };
// export default AlertBox;



// WEBPACK FOOTER //
// ./src/lib/alertbox/src/index.js